export default {
  slug: "dotmemory",
  code: "DM",
  label: "dotMemory",
  krakenDir: "dotMemory",
  thumbnailColor: "#FDB60D",
  logoFamily: "jb",
};
